module.exports = __webpack_public_path__ + "img/welcome_12.6dcb73e9.jpg";